import CommonResult from 'app/components/OrderPayment/Common/CommonResult';
import React from 'react';

const WechatResultWay = () => {
  return <CommonResult />;
};

export default WechatResultWay;
